/* This file is autogenerated, see readme.md for instructions */
import CheckSvgIcon from '@bloomreach/banana-theme/icons/check.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CheckIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CheckSvgIcon />
    </Icon>
  );
});

CheckIcon.displayName = 'CheckIcon';

export default CheckIcon;
